import { FC } from 'react'

import { Flex } from '@mantine/core'

type Props = {
  src: string
}

const FeatureCardIcon: FC<Props> = ({ src }) => {
  if (!src) return null
  return (
    <Flex
      align={'center'}
      justify={'center'}
      sx={(theme) => ({
        img: {
          width: 16,
          height: 16,
        },
        [theme.fn.largerThan('sm')]: {
          boxShadow: `0px 0px 1px 0px #0000000A,
0px 2px 8px 0px #0000000A,
0px 10px 16px 0px #0000000A
`,
          width: 80,
          height: 80,
          borderRadius: '50%',
          img: {
            width: 40,
            height: 40,
          },
        },
      })}
    >
      <img loading="lazy" src={src} alt="" />
    </Flex>
  )
}

FeatureCardIcon.displayName = 'FeatureCardIcon'

export default FeatureCardIcon
